<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <v-container>
              <v-layout>
                <v-flex xs12 md4>
                  <v-select
                    v-model="nivelValue"
                    :items="nivelSelect"
                    label="Nivel"
                    data-vv-name="listaNiveles"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select
                    v-model="regionValue"
                    :items="regionSelect"
                    label="Region"
                    item-text="nombre"
                    item-value="code"
                  ></v-select>
                </v-flex>
                <v-btn
                  fab
                  dark
                  color="teal"
                  title="Filtrar contratos"
                  @click="filterProv()"
                >
                  <v-icon dark>filter_list</v-icon>
                </v-btn>
                <v-btn
                  fab
                  dark
                  color="red darken-4"
                  title="Limpiar filtros"
                  @click="clear()"
                >
                  <v-icon dark>clear_all</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
            <!-- TABLA PROVEEDORES -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <div v-if="alerta">
                <alert-empty></alert-empty>
              </div>
              <grid-recepcion
                v-if="!alerta"
                :itemsDocumento="itemsDocumento"
                :rowsTable="rowsTable"
                :nPaginas="Math.ceil(itemsDocumento.length / rowsTable)"
              ></grid-recepcion>
            </template>
            <!-- TABLA PROVEEDORES -->
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title class="headline" style="font-weight: bold"
            >Se encontraron los siguientes errores:</v-card-title
          >

          <v-card-title v-if="arrNumGuia.length > 0" style="font-weight: bold"
            >Números de guías que no coinciden:</v-card-title
          >
          <ul v-if="arrNumGuia.length > 0">
            <li v-for="(numGuia, index) in arrNumGuia" :key="index">
              {{ numGuia }}
            </li>
          </ul>
          <v-card-title
            v-if="arrIdCodBarraContenedora.length > 0"
            style="font-weight: bold"
            >Códigos barra contenedora incorrectos:</v-card-title
          >
          <ul v-if="arrIdCodBarraContenedora.length > 0">
            <li
              v-for="(idBarraContenedora, index) in arrIdCodBarraContenedora"
              :key="index"
            >
              {{ idBarraContenedora }}
            </li>
          </ul>
          <v-card-title v-if="arrFecha.length > 0" style="font-weight: bold"
            >Las siguientes fechas no deben ser anteriores a la fecha de
            envío:</v-card-title
          >
          <ul v-if="arrFecha.length > 0">
            <li v-for="(fecha, index) in arrFecha" :key="index">{{ fecha }}</li>
          </ul>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="indigo darken-1" flat="flat" @click="dialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import GridRecepcion from "@/modules/aplicacion/views/recepcion/GridRecepcion.vue";
import Loading from "@/views/ui/Loading.vue";
import DataAdjunto from "@/components/AdjuntoData.vue";

export default {
  name: "recepcion-tab",
  components: {
    GridRecepcion,
    AlertEmpty,
    Loading,
    DataAdjunto,
  },
  props: {
    tabSelected: "",
  },
  data() {
    return {
      text: "En construccion",
      arrNumGuia: [],
      arrIdCodBarraContenedora: [],
      arrFecha: [],
      loading: false,
      dialog: false,
      desactivarUpload: false,
      proveedor: {},
      rowsTable: 20,
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      itemsDocumento: [],
      nivelSelect: [],
      regionSelect: [],
      nivelValue: null,
      regionValue: null,
      tipoUsuario: "",
      filter: false,
      proceso: "",
      alerta: false,
    };
  },

  mounted() {
    this.loadData();
  },

  created() {
    this.subProceso = this.$store.getters.subProTabSelectedStored;
    this.idContrato = this.$store.getters.contratoStored;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.tipoUsuario = this.$store.getters.userLogged.tipo;
    this.tipeArchive = ".xlsx";
  },
  methods: {
    async loadDocumentosFilter() {
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,

        idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      return await axios
        .post("/recepcion/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      this.itemsDocumento = await this.loadDocumentosFilter();
      //console.log("largo:" + this.itemsDocumento.length);
      if (this.itemsDocumento.length > 0) {
        this.loadNivelSelect();
        this.loadRegionSelect();
        this.alerta = false;
      } else {
        this.alerta = true;
      }
      this.loading = false;
    },

    loadNivelSelect() {
      let niv = [];
      this.itemsDocumento.forEach(function (d) {
        let index = niv.findIndex((x) => x.nivel == d.nivel);
        if (index === -1) {
          if (d.nivel != null && d.nivel != "") {
            niv.push(d.nivel);
          }
        }
      });
      this.nivelSelect = niv;
    },
    loadRegionSelect() {
      let tipM = [];
      this.itemsDocumento.forEach(function (d) {
        let index = tipM.findIndex((x) => x.region == d.region);
        if (index === -1) {
          if (d.region != null && d.region != "") {
            tipM.push(d.region);
          }
        }
      });
      this.regionSelect = tipM;
    },
    clear() {
      this.nivelValue = "";
      this.regionValue = "";
      this.loadData();
    },
    loadSelected() {},
    selected(tab) {
      this.tabSelect = tab;
    },
    filterProv() {
      this.filter = true;
      this.loadData();
    },
    descargaPlantilla() {
      this.dialogLoading = true;
      let that = this;
      axios
        .get("/recepcion/download/" + this.idContrato, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute(
            "download",
            "PLANTILLA_BASE_RECEPCION_MATERIALES.xlsx"
          );
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    processFile() {
      this.desactivarUpload = true;
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
      };
      axios
        .post("/recepcion/readExcel", this.body)
        .then((response) => {
          this.resp = response.data;
          // window.getApp.$emit("APP_SAVE");
          if (
            this.resp.numGuiaErrors.length > 0 ||
            this.resp.idCodBarraContenedoraErrors.length > 0 ||
            this.resp.fechaErrors.length > 0
          ) {
            this.arrNumGuia = this.resp.numGuiaErrors;
            this.arrIdCodBarraContenedora =
              this.resp.idCodBarraContenedoraErrors;
            this.arrFecha = this.resp.fechaErrors;
            this.dialog = true;
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          } else {
            this.cargaMasiva();
          }
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          }
        });
    },
    cargaMasiva() {
      this.desactivarUpload = true;
      this.loading = true;
      let base64EncodedStr = this.base64Value;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        documento: base64EncodedStr,
        idContrato: idContrato,
        valido: true,
        filename: this.filenameValue,
      };
      axios
        .post("/recepcion/cargaMasiva", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loadData();
          this.loading = false;
          this.desactivarUpload = false;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loadData();
            this.loading = false;
            this.desactivarUpload = false;
          }
        });
    },
  },
};
</script>
